module.exports = __webpack_public_path__ + "static/media/Upp_Login.eea9e5a5.png";